import React from 'react';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';

import { formatDate } from '../../utils/DateTime';

export const InsuranceInfo = ({ t, classes, carrier }) => (
  <div className={classes.detailsSection}>
    <h2 className={classnames(classes.headline7, classes.infoTitle)}>
      {t('Insurance Information')}
    </h2>
    <Grid container spacing={16}>
      <Grid item lg={6} className={classes.gridItem}>
        <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
          {t('Insurance Provider')}
        </p>
        <p className={classes.body2}>{carrier.insuranceProvider || '--'}</p>
      </Grid>
      <Grid item lg={6} className={classes.gridItem}>
        <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
          {t('Insurance Policy Number')}
        </p>
        <p className={classes.body2}>{carrier.insurancePolicyNumber || '--'}</p>
      </Grid>
      <Grid item lg={6} className={classes.gridItem}>
        <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
          {t('Policy Starts')}
        </p>
        <p className={classes.body2}>
          {formatDate(carrier.insuranceEffectiveDate, {
            uppercase: true
          })}
        </p>
      </Grid>
      <Grid item lg={6} className={classes.gridItem}>
        <p className={classnames(classes.subtitle3, classes.infoItemTitle)}>
          {t('Policy Ends')}
        </p>
        <p className={classes.body2}>
          {formatDate(carrier.insuranceExpirationDate, {
            uppercase: true
          })}
        </p>
      </Grid>
    </Grid>
  </div>
);

export default InsuranceInfo;
